import {
    connect,
} from 'react-redux';

import {
    reduxForm,
} from 'redux-form';

import Validator from 'validatorjs';

import {
    clearCart,
} from 'components/shop/actions';

import ShopService from '../ShopService';

import Checkout from '../components/Checkout';

const validate = (values) => {
    Validator.useLang('nl');

    const rules = {
        name: 'required',
        address: 'required',
        email: 'required|email',
        phone: 'required',
        pickupDate: 'required',
    };

    const validator = new Validator(values, rules);
    validator.setAttributeNames({
        name: 'naam',
        address: 'adres',
        email: 'e-mail',
        phone: 'telefoon',
        pickupDate: 'afhaaldatum',
    });
    validator.check();

    return validator.errors.all();
};

const onSubmit = values => new Promise(async (resolve, reject) => {
    try {
        const body = new FormData();
        body.append('action', 'guest-entries/save');
        body.append('sectionId', 8);
        body.append('fields[order_name]', values.name);
        body.append('fields[order_address]', values.name);
        body.append('fields[order_email]', values.email);
        body.append('fields[order_phone]', values.phone);
        body.append('fields[order_products]', ShopService.getCartOverviewInText());
        body.append('fields[order_pickupDate]', Math.round(values.pickupDate / 1000));
        body.append('fields[order_remarks]', values.remarks);

        const response = await fetch('/', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
            },
            body,
        });
        const json = await response.json();

        resolve(json);
    } catch (error) {
        reject(error);
    }
});

const onSubmitSuccess = (result, dispatch) => {
    dispatch(clearCart());
};

const CheckoutWithReduxForm = reduxForm({
    form: 'checkout',
    onSubmit,
    onSubmitSuccess,
    validate,
})(Checkout);

const mapStateToProps = ({ shop }) => ({
    productsLoaded: Object.keys(shop.products).length > 0,
    cart: shop.cart,
});

const container = connect(
    mapStateToProps,
)(CheckoutWithReduxForm);

export default container;



// WEBPACK FOOTER //
// ./resources/components/shop/containers/CheckoutContainer.js